/**
 * Checks if the provided value is null, undefined, empty string, or *
 */
export const hasMarineValue = (value) =>
  value !== null && value !== undefined && value !== '' && value !== '*';

/**
 * Returns the value when its not null, undefined, empty string, or *.
 * Otherwise returns the fallback.
 */
export const displayMarineValue = (value, fallback = '--') =>
  hasMarineValue(value) ? value : fallback;

export const displayMarineValueWithUnit = (value, unit, fallback = '--') =>
  hasMarineValue(value) ? `${value}${unit}` : fallback;

export const joinMarineValues = (values, separator = ' / ', fallback = '--') => {
  const displayValues = values.filter(hasMarineValue);

  return displayValues.length ? displayValues.join(separator) : fallback;
};
